import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfigOption, FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormlyOpenItemPaymentListComponent } from './components/formly-open-item-payment-list/formly-open-item-payment-list.component';

@Component({
  selector: 'app-formly-select-button',
  template: `
    <p-selectButton
      [formControl]="formControl"
      [formlyAttributes]="field"
      [options]="props.options"
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false"
      [attr.data-testid]="props.attributes?.['data-testid']"
    >
      <ng-template let-option pTemplate="item">
        <span>{{ option.label | translate }}</span>
      </ng-template>
    </p-selectButton>
  `,
  standalone: true,
  imports: [
    FormlyModule,
    ReactiveFormsModule,
    SelectButtonModule,
    TranslatePipe,
  ],
})
export class FormlySelectButtonComponent extends FieldType<FieldTypeConfig> {
}

export const FINANCE_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-select-button', component: FormlySelectButtonComponent, wrappers: ['simple-title'] },
  { name: 'formly-open-item-payment-list', component: FormlyOpenItemPaymentListComponent, wrappers: ['simple-title'] },
  //{ name: 'formly-bank-account-dropdown', component: BankAccountDropdownComponent, wrappers: ['simple-title'] },
]
